<template>
    <div class="bg-white rounded box-shadow my-1 p-3">
        <b-modal
                id="structure-modal"
                size="lg"
                title="Structure Information"
                hide-footer
        >
            <div v-show="show"
                 class="alert alert-danger alert-dismissible fade show"
                 role="alert">
                        <span v-for="(err, index) in validation_errors" :key="index">
                          {{ err[0] }} <br/>
                        </span>
            </div>
            <div class="modal-content bg-white rounded box-shadow">
                <div class="form-row">
                    <div class="col-md-12 col-sm-12 col-lg-12">
                        <label for="land_id" class="col-form-label col-form-label-sm"
                        >Select Land <span class="c-required">*</span></label
                        >
                        <select
                                v-model="structure.land_id"
                                v-validate="'required'"
                                id="land_id"
                                name="land_id"
                                class="form-control form-control-sm"
                                @change="landOwnership(structure.land_id)"
                        >
                            <option selected value="selected"
                            >Select Land Ownership Type
                            </option
                            >
                            <option v-for="land in lands" v-bind:value="land.id"
                            >{{ land.id }} : {{ land.mouza.desc }} :
                                {{ land.land_type.desc }}
                            </option
                            >
                        </select>
                        <div class="invalid-feedback">Please Select Valid Land</div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <label for="c_structure_uses_id" class="col-form-label col-form-label-sm"
                        >Structure used for <span class="c-required">*</span></label
                        >
                        <select
                                v-model="structure.c_structure_uses_id"
                                v-validate="'required'"
                                id="c_structure_uses_id"
                                name="c_structure_uses_id"
                                class="form-control form-control-sm"
                        >
                            <option selected value="selected">Structure used for</option>
                            <option v-for="stru_use in stru_uses" v-bind:value="stru_use.id"
                            >{{ stru_use.id }} : {{ stru_use.desc }}
                            </option
                            >
                        </select>
                        <div class="invalid-feedback">Please Select Structure uses</div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <label for="c_structures_des_id" class="col-form-label col-form-label-sm"
                        >Structure Description <span class="c-required">*</span></label
                        >
                        <select
                                v-model="structure.c_structures_des_id"
                                v-validate="'required'"
                                id="c_structures_des_id"
                                name="c_structures_des_id"
                                class="form-control form-control-sm"
                                @change="desToUnit(structure.c_structures_des_id)"
                        >
                            <option selected value="selected">Structure Description</option>
                            <option v-for="stru_des in stru_desc" v-bind:value="stru_des.id"
                            >{{ stru_des.id }} : {{ stru_des.desc }}
                            </option
                            >
                        </select>
                        <div class="invalid-feedback">
                            Please Select Valid Structure Description
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <label for="stru_length" class="col-form-label col-form-label-sm"
                        >Structure Length</label
                        >
                        <input
                                type="number"
                                step="0.1"
                                v-model="structure.length"
                                id="stru_length" name="stru_length"
                                class="form-control form-control-sm"
                                placeholder="Length"
                        />
                        <div class="invalid-feedback">
                            Please provide structure length
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <label for="stru_width" class="col-form-label col-form-label-sm"
                        >Structure Width</label
                        >
                        <input
                                type="number"
                                step="0.1"
                                v-model="structure.width"
                                id="stru_width"
                                class="form-control form-control-sm"
                                placeholder="Width"
                        />
                        <div class="invalid-feedback">
                            Please provide structure width
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <label for="stru_height" class="col-form-label col-form-label-sm"
                        >Structure Height</label
                        >
                        <input
                                type="number"
                                step="0.1"
                                v-model="structure.height"
                                id="stru_height"
                                class="form-control form-control-sm"
                                placeholder="Height"
                        />
                        <div class="invalid-feedback">
                            Please provide structure height
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <label for="c_unit_id" class="col-form-label col-form-label-sm"
                        >Structure Unit <span class="c-required">*</span></label
                        >
                        <select
                                v-model="structure.c_unit_id"
                                v-validate="'required'"
                                id="c_unit_id"
                                name="structure_unit"
                                class="form-control form-control-sm"
                                disabled
                        >
                            <option selected value="selected">Select structure unit</option>
                            <option v-for="unit in units" v-bind:value="unit.id"
                            >{{ unit.id }} : {{ unit.desc }}
                            </option
                            >
                        </select>
                        <div class="invalid-feedback">Please Select Valid Unit</div>
                    </div>
                </div>

                <div class="form-row pb-3">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <label for="quantity_num" class="col-form-label col-form-label-sm"
                        >Structure Quantity <span class="c-required">*</span></label
                        >
                        <input
                                type="number"
                                step="1"
                                v-validate="'required|numeric'"
                                v-model="structure.quantity_num"
                                name="quantity_num"
                                id="quantity_num"
                                placeholder="Structure Quantity"
                                class="form-control form-control-sm"
                        />
                        <div class="invalid-feedback">
                            Please provide structure Quantity
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <label for="owner_conduct" class="col-form-label col-form-label-sm"
                        >Owner Conduct <span class="c-required">*</span></label
                        >
                        <select
                                v-model="structure.c_owner_conduct_id"
                                v-validate="'required'"
                                id="owner_conduct"
                                name="owner_conduct"
                                class="form-control form-control-sm"
                        >
                            <option selected value="selected"
                            >Structure Owner conduct type
                            </option
                            >
                            <option
                                    v-for="owner_conduct in owner_conducts"
                                    v-bind:value="owner_conduct.id"
                            >{{ owner_conduct.id }} : {{ owner_conduct.desc }}
                            </option
                            >
                        </select>
                        <div class="invalid-feedback">Please Select Owner Conduct</div>
                    </div>
                </div>
                <div v-if="!cclShow">
                    <h5 class="card-header">CCL Information</h5>
                    <br/>
                    <div class="form-row">
                        <div class="col-md-6 col-sm-6 col-lg-6">
                            <label for="la_case" class="col-form-label col-form-label-sm"
                            >LA CASE</label
                            >
                            <input
                                    type="text"
                                    v-model="structure.la_case"
                                    id="la_case" name="la_case"
                                    class="form-control form-control-sm"
                                    placeholder="LA Case"
                            />
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-6">
                            <label for="ccl_amount" class="col-form-label col-form-label-sm"
                            >CCL Amount <span class="c-required">*</span></label
                            >
                            <input
                                    type="number"
                                    v-model="structure.ccl_amount"
                                    v-validate="'decimal'"
                                    id="ccl_amount" name="ccl_amount"
                                    class="form-control form-control-sm"
                                    placeholder="CCL Amount"
                            />
                            <div class="invalid-feedback">
                                Please provide Valid CCL Amount
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6 col-sm-6 col-lg-6">
                            <label for="book_no" class="col-form-label col-form-label-sm"
                            >Award Book No.</label
                            >
                            <input
                                    type="text"
                                    v-model="structure.book_no"
                                    id="book_no" name="book_no"
                                    class="form-control form-control-sm"
                                    placeholder="Award book No."
                            />
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-6">
                            <label for="book_sub_no" class="col-form-label col-form-label-sm"
                            >Award Book Sub Serial</label
                            >
                            <input
                                    type="text"
                                    v-model="structure.book_sub_no"
                                    id="book_sub_no" name="book_sub_no"
                                    class="form-control form-control-sm"
                                    placeholder="Award Book Sub serial"
                            />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6 col-sm-6 col-lg-6">
                            <label for="cheque_no" class="col-form-label col-form-label-sm"
                            >LA Cheque No.</label
                            >
                            <input
                                    type="text"
                                    v-model="structure.cheque_no"
                                    id="cheque_no" name="cheque_no"
                                    class="form-control form-control-sm"
                                    placeholder="DC LA Cheque No."
                            />
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-6">
                            <label class="col-form-label col-form-label-sm"
                            >Cheque Date</label
                            >
                            <datepicker
                                    v-model="structure.cheque_date"
                                    :input-class="'form-control form-control-sm'"
                                    :format="customFormatter"
                            ></datepicker>
                        </div>
                    </div>
                </div>

                <div class="form-row mt-3 mb-3">
                    <div class="float-right">
                        <b-button
                                variant="success"
                                v-if="!this.btn_edit"
                                class="form-control-sm mr-2"
                                @click.prevent="save"
                        >Add Structure
                        </b-button
                        >
                        <b-button
                                variant="warning"
                                v-if="this.btn_edit"
                                class="form-control-sm mr-2"
                                @click.prevent="update"
                        >Update
                        </b-button
                        >
                        <b-button
                                size="sm"
                                variant="danger"
                                class="form-control-sm"
                                @click="$bvModal.hide('structure-modal')"
                        >
                            Cancel
                        </b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import http from "@state/http";
    import Datepicker from "vuejs-datepicker";
    import moment from "moment";

    export default {
        props: ["structure", "cclShow", "btn_edit", "lands"],
        components: {Datepicker},

        data() {
            return {
                structures: [],
                owner_conducts: [],
                stru_desc: [],
                stru_uses: [],
                units: [],
                upazillas: [],
                modalTitle: "",
                validation_errors: {},
                structure_id: false,
                landChk: false,
                show: false,
            };
        },
        mounted() {
            this.structure.ses_id = this.$route.params.ses_id;
            this.getCodes();
        },
        methods: {
            customFormatter(date) {
                this.structure.cheque_date = moment(date).format("YYYY-MM-DD");
                return moment(date).format("YYYY-MM-DD");
            },
            landOwnership(LandId) {
                let obj = this.lands;
                let landChk = null;
                Object.keys(obj).forEach(function (key) {
                    let ObjlandId = (key, obj[key])["id"];
                    if (ObjlandId == LandId) {
                        landChk = (key, obj[key])["c_land_ownership_id"];
                        return;
                    }
                });

                this.$emit("cclShowUpdate", landChk != 1 ? 1 : 0);
                this.landChk = landChk;
            },
            desToUnit(DesId) {
                this.structure.c_unit_id = this.stru_desc[DesId - 1].c_unit_id;
            },
            save() {
                this.structure.ses_id = this.$route.params.ses_id;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/ses/structures", this.structure)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$emit("resetForm");
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.$emit("getPersonStructures");
                                } else {
                                    this.$bvToast.toast("Update Failed", {
                                        title: "Error",
                                        autoHideDelay: 5000,
                                        variant: "danger"
                                    });
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            update() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .put("api/ses/structures/" + this.structure.id, this.structure)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$bvModal.hide("structure-modal");
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.$emit("getPersonStructures");
                                } else {
                                    this.$bvToast.toast("Update Failed", {
                                        title: "Error",
                                        autoHideDelay: 5000,
                                        variant: "danger"
                                    });
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            getCodes() {
                http.get("api/ses/structure/codes").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.owner_conducts = data.owner_conducts;
                        this.stru_desc = data.stru_desc;
                        this.stru_uses = data.stru_uses;
                        this.units = data.units;
                    }
                });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },
        },
    };
</script>
<style>
    .c-required {
        color: red;
    }
</style>